import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
import * as React from 'react';

const useStyles = makeStyles({
  iconStyle: {
    fill: 'none',
    '&>path': {
      stroke: 'currentColor',
    },
  },
});

function CoffeeIcon(props: SvgIconProps) {
  const classes = useStyles();

  return (
    <SvgIcon {...props} className={classes.iconStyle}>
      <path
        d="M18 8h1a4 4 0 110 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

const MemoCoffeeIcon = React.memo(CoffeeIcon);
export default MemoCoffeeIcon;
